export default __webpack_public_path__ + "media/images/favicon-c47c09f538e0c0303fea1c64a50364d5.ico";